import React from 'react'
import Modal from 'react-modal'
import icErrorServer from '../../assets/img/error_server.svg'
import icErrorInternet from '../../assets/img/error_internet.svg'
import icAlert from '../../assets/img/ic_alert.svg'
import ButtonYapp from '../../Components/Buttons/ButtonYapp'

function ModalServerError(props) {
  const {isOpen, setIsOpen, imgName, title, text, btnText, className} = props

  function closeModal(params) {
    setIsOpen(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={null}
      onRequestClose={closeModal}
      className="modal-custom"
      overlayClassName="modal-custom-bg"
      contentLabel="ModalReported"
      ariaHideApp={false}>
      <button className="btn-circle-close" onClick={closeModal}>
        <i className="icon-close"></i>
      </button>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <img
          src={
            imgName == 'icErrorServer'
              ? icErrorServer
              : imgName == 'icErrorInternet'
              ? icErrorInternet
              : icAlert
          }
          alt="Error"
          className="mb-3 "
        />
        <h4 className="txt-1--bold-db">{title}</h4>
        <p className={`txt-3--light-db text-center mb-30 ${className}`}>
          {text}
        </p>
      </div>
      <div className="d-flex justify-content-center align-items-center flex-column">
        <ButtonYapp
          className="btn-default--small btn-next"
          onClick={closeModal}
          title={btnText}
        />
      </div>
    </Modal>
  )
}

export default ModalServerError
